import React from 'react';
import Component from '@vfuk/core-modal';
const Modal = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Modal;
